// @ts-ignore
import { FC } from 'react'
import { FaGithub, FaRunning } from 'react-icons/fa'
// @ts-ignore
import React from 'react'
// @ts-ignore
import styles from './projectCard.module.scss'

interface LinkButtonProps {
  isGitHub: boolean
  link: string
}

const LinkButton: FC<LinkButtonProps> = (props) => {
  return (
    <button
      className={props.isGitHub ? `${styles.github}` : `${styles.hosted}`}
      onClick={() => window.open(props.link, '_blank')}
      rel="noreferrer"
    >
      {props.isGitHub ? <FaGithub /> : <FaRunning />}
      {props.isGitHub ? ' GitHub' : ' Live Here'}
    </button>
  )
}

export { LinkButton }
